export enum TypeTransactionEnum {
    inv =   'Inversion',
    cdf =   'Cambio de fondo',
    res =   'Rescate',
    sdf =   'Suscripcion de flujo',
    tdi =   'Traspaso ingreso',
    tde =   'Traspaso egreso'
}